import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllSupportMessagesService = (page = 1) => {
  return HTTP_CLIENT.get(Endpoint.support.get + `?page=${page}`);
};

const DeleteSupportMessageService = (id: number) => {
  return HTTP_CLIENT.delete(
    Endpoint.support.delete.replace(":id", id.toString())
  );
};

export { GetAllSupportMessagesService, DeleteSupportMessageService };
